import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    isActive: 0,
  },
  getters: {

  },
  mutations: {
    addcount(state, index) {
      state.isActive = index
    }
  },
  actions: {

  }
})

export default store